import { getBackendURL } from "./getBaseUrl";
import { globalConfig } from "./storytellClient";

type ApiFetchScope = "project-scoped";

type ApiFetchOptions = Omit<RequestInit, "headers"> & {
  scope: ApiFetchScope;
  authToken?: string;
  projectIdOverride?: string;
  headers?: Record<string, string>;
};

export async function apiFetch(path: string, options: ApiFetchOptions): Promise<Response> {
  const headers: Record<string, string> = { ...(options.headers ?? {}) };

  const requireAuth = () => {
    if (!options.authToken) {
      throw new Error(`apiFetch(${path}): ${options.scope} requires authToken`);
    }
    headers.Authorization = `Bearer ${options.authToken}`;
  };

  switch (options.scope) {
    case "project-scoped": {
      requireAuth();
      const projectId = options.projectIdOverride ?? globalConfig.getProjectId?.();
      if (!projectId) {
        throw new Error(`apiFetch(${path}): project-scoped requires projectId`);
      }
      headers["X-Project-Id"] = projectId;
      break;
    }
  }

  const bodyIsFormData = typeof FormData !== "undefined" && options.body instanceof FormData;
  if (!headers["Content-Type"] && !bodyIsFormData) {
    headers["Content-Type"] = "application/json";
  }

  return fetch(`${getBackendURL()}${path}`, { ...options, headers });
}
